import { useMemo } from 'react';
import { ChevronLeft } from '@mui/icons-material';
import { StackProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useScheduledActionTitleQuery } from '../../../../api/gql';
import { PageHeader } from '../../../../components/PageHeader';
import { getActionTransKey } from '../../../../utils/invoice';

type Props = {
  taskId: string;
} & StackProps;

export const ScheduledActionPageHeader = ({ taskId, ...rest }: Props) => {
  const { t } = useTranslation('page-admin-task-detail');
  const { data } = useScheduledActionTitleQuery({ id: taskId });

  const title = useMemo(() => {
    if (!data?.scheduledAction) {
      return '';
    }

    const { action, vendorName, customerName, invoiceClaim: isClaim } = data.scheduledAction;
    const actionName = t(`header.${getActionTransKey(action)}`);

    if (isClaim) {
      return t('header.titleClaim', {
        action: actionName,
        customer: customerName,
      });
    }

    return t('header.title', {
      action: actionName,
      vendor: vendorName,
      customer: customerName,
    });
  }, [data?.scheduledAction, t]);

  return <PageHeader title={title} backRouteTo={'..'} Icon={ChevronLeft} {...rest} />;
};
